module.exports = __webpack_public_path__ + "img/5425003947278.c89d146f.png";